module.exports = __webpack_public_path__ + "img/ovcharenko.910525f7.png";